import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Switch } from "antd";
import React from "react";
import Swal from "sweetalert2";
import { deleteGoods } from "../../../service/shopApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editGoodInfo } from "../../../service/shopApi";
import { deleteModifiedUpdate } from "../../../service/shopApi";

function Expertgoods({ shopData, setEditGoods, setIndex }) {
  let w = window.innerWidth;
  const queryClient = useQueryClient();
  const deleteModifiedUpdateMutation = useMutation(deleteModifiedUpdate, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expertShop"],
      });
    },
  });
  const saleableMutation = useMutation(editGoodInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expertShop"],
      });
    },
  });
  const deleteGoodsMutation = useMutation(deleteGoods, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expertShop"],
      });
    },
  });
  const deleteExpertGoods = (id) =>
    Swal.fire({
      title: "حذف محصول",
      text: "در صورت تایید،این محصول به طور کلی از فروشگاه شما حذف خواهد شد",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "تایید",
      cancelButtonText: "لغو",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteGoodsMutation.mutate(id);
        Swal.fire({
          title: "حذف محصول",
          text: "محصول مورد نظر با موفقیت از فروشگاه شما حذف گردید",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        });
      }
    });
  return (
    <div className="bg-white w-full p-3 max-lg:p-2 rounded-lg h-full ">
      {shopData?.goods?.map((data, index) => {
        return (
          <div
            className={`flex p-2 max-xl:p-1 rounded-md flex-row items-center justify-between ${
              (index + 1) % 2 !== 0 ? "bg-slate-100" : "bg-white"
            }`}
          >
            <section className="flex flex-row gap-1 w-1/4 max-lg:w-1/3 whitespace-nowrap text-ellipsis ">
              <p className=" max-lg:text-[10px]">{index + 1}-</p>
              <p className="text-ellipsis max-lg:text-[10px] max-lg:w-40 overflow-hidden">
                {data?.title}
              </p>
            </section>
            {data.status === "CONFIRMED" && data?.modified?.status !== "REJECTED" && data?.modified?.status !== "PENDING"? (
              <section>
                <div>
                  <Switch
                    checkedChildren={"موجود"}
                    unCheckedChildren={"ناموجود"}
                    size={w >= 1024 ? "default" : "small"}
                    onChange={(e) =>
                      saleableMutation.mutate({
                        saleable: e,
                        categoryId: data?.categoryId,
                        goodId: data?.id,
                      })
                    }
                    className=" bg-red-500 :!bg-green-400 hover:bg-pink-300 !font-body max-lg:w-14 "
                    defaultChecked={data?.saleable}
                  />
                </div>
              </section>
            ) : (
              <section>
                <label
                  className={`${
                    data.status === "REJECTED"||data?.modified?.status === "REJECTED"
                      ? "bg-red-500 text-white"
                      : "bg-yellow-300"
                  } px-2 max-lg:px-1 py-1 rounded-full max-lg:text-[10px] animate-pulse`}
                >
                  {data.status === "REJECTED"||data?.modified?.status === "REJECTED"
                    ? "تایید نشده "
                    : "درحال بررسی..."}{" "}
                </label>
              </section>
            )}

            <section className="flex flex-row gap-3">
              <div
                onClick={() => deleteExpertGoods(data.id)}
                className="flex flex-row items-center text-red-600 cursor-pointer hover:scale-110"
              >
                <CloseOutlined />
                {w >= 1024 ? <p>حذف</p> : ""}{" "}
              </div>
              <Button
                onClick={() => {
                  if (data?.modified && data?.modified?.status === "REJECTED") {
                    Swal.fire({
                      title: "دلیل رد درخواست",
                      icon: "error",
                      text: data?.record?.comment,
                      showConfirmButton: true,
                      confirmButtonText: "تایید",
                    }).then((result)=>{
                      if(result.isConfirmed){
                        deleteModifiedUpdateMutation.mutate(data?.id);
                        Swal.fire(
                          "",
                          "تغییرات قبلی شما با موفقیت حذف شد!",
                          "success"
                        );
                      }
                    });
                    setEditGoods(false);
                  }
                  if (data?.modified && data?.modified?.status === "PENDING") {
                    Swal.fire({
                      title: "ثبت ویرایش",
                      icon: "warning",
                      text: " این محصول دارای یک تغییر در دست بررسی است برای ثبت ویرایش جدید باید ابتدا درخواست ویرایش قبل را لغو کنید .آیا مایل به انجام این کار هستید؟",
                      showConfirmButton: true,
                      showCancelButton: true,
                      cancelButtonText: "لغو",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "تایید",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        deleteModifiedUpdateMutation.mutate(data?.id);
                        Swal.fire(
                          "",
                          "تغییرات قبلی شما با موفقیت حذف شد!",
                          "success"
                        );
                      }
                    });
                  } else {
                    setEditGoods(true);
                    setIndex(index);
                  }
                }}
                className={`!text-white bg-blue-500
                 max-lg:text-xs`}
                icon={<EditOutlined />}
              >
                {w >= 1024 ? "ویرایش" : undefined}
              </Button>
            </section>
          </div>
        );
      })}
    </div>
  );
}

export default Expertgoods;
